import { type JobContractType } from "types/enum";

import type HeaderInfoExampleApiData from "./ownerHeaderInfo.api.json";

export function getHeaderInfoFromResponse(
    data: typeof HeaderInfoExampleApiData,
): IHeaderInfoResponse {
    return {
        builderId: data.builderId,
        builderName: data.builderName,
        logoPath: data.logoPath,
        mobileLogoPath: data.mobileLogoPath,
        phone: data.phone,
        fax: data.fax,
        formattedAddress: data.formattedAddress,
        projectManagers: data.projectManagers ?? [],
        jobRunningTotal: {
            hasJobsitePermission: data.jobRunningTotal?.hasJobsitePermission ?? false,
            hasRunningTotalPermission: data.jobRunningTotal?.hasRunningTotalPermission ?? false,
            jobRunningTotal: data.jobRunningTotal?.jobRunningTotal ?? null,
            pricePerUnitArea: data.jobRunningTotal?.pricePerUnitArea ?? null,
            areaUnit: data.jobRunningTotal?.areaUnit ?? null,
            revisedClientPrice: data.jobRunningTotal?.revisedClientPrice ?? null,
            originalClientPrice: data.jobRunningTotal?.originalClientPrice ?? null,
            isWorksheetBudgeted: data.jobRunningTotal?.isWorksheetBudgeted ?? null,
            shouldUseNewClientPriceValues:
                data.jobRunningTotal?.shouldUseNewClientPriceValues ?? false,
            jobContractType: data.jobRunningTotal?.jobContractType ?? null,
        },
        linkedJobs: {
            disabled: data.linkedJobs?.disabled ?? false,
            jobs: data.linkedJobs?.jobs ?? [],
        },
    };
}

export interface IHeaderInfoRequest {
    selectedJobIds?: number[];
}

export class IHeaderInfoResponse {
    builderId: number;
    builderName: string | null;
    logoPath: string | null;
    mobileLogoPath: string | null;
    phone: string | null;
    fax: string | null;
    formattedAddress: string | null;
    jobRunningTotal: IJobRunningTotalResponse;
    projectManagers: IOwnerProjectManager[];
    linkedJobs: ILinkedJobsResponse;
}

export interface IJobRunningTotalResponse {
    hasJobsitePermission: boolean;
    hasRunningTotalPermission: boolean;
    jobRunningTotal: number | null;
    pricePerUnitArea: number | null;
    areaUnit: string | null;
    revisedClientPrice: number | null;
    originalClientPrice: number | null;
    isWorksheetBudgeted: boolean | null;
    shouldUseNewClientPriceValues: boolean | null;
    jobContractType: JobContractType | null;
}

export interface IOwnerProjectManager {
    name: string;
    phone: string;
    userId: number;
}

interface ILinkedJobsResponse {
    disabled: boolean;
    jobs: ILinkedJob[];
}

interface ILinkedJob {
    id: number;
    jobName: string;
    ownerName: string;
    hasCredentials: boolean;
}
